import HttpService from "./HttpService";
const API_ENDPOINT = "/employment-status";

const EmploymentStatusService = {
  async getStatuses() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getStatusesPaginated(pageConfig) {
    const pageConfigParams = new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(
        `${API_ENDPOINT}-paginated?${pageConfigParams}`
      );
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async addEmploymentStatus(data) {
    try {
      const response = await HttpService.post(API_ENDPOINT, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async editEmploymentStatus(id) {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/${id}/edit`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateEmploymentStatus(employmentStatusId, data) {
    try {
      const response = await HttpService.put(
        `${API_ENDPOINT}/${employmentStatusId}`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async deleteEmploymentStatus(employmentStatusId) {
    try {
      const response = await HttpService.delete(
        `${API_ENDPOINT}/${employmentStatusId}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default EmploymentStatusService;
